import { render, staticRenderFns } from "./ProductListSwipe.vue?vue&type=template&id=ea47a09a&scoped=true&"
import script from "./ProductListSwipe.vue?vue&type=script&lang=js&"
export * from "./ProductListSwipe.vue?vue&type=script&lang=js&"
import style0 from "./ProductListSwipe.vue?vue&type=style&index=0&id=ea47a09a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea47a09a",
  null
  
)

export default component.exports